
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicCreditCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TCreditCard"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bt_apr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bt_duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comparison_apr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicImage"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plan_features"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicPlanFeature"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"purchases_intro_apr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"purchases_intro_duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicUrl"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullCreditCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TCreditCard"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicCreditCard"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bt_available"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bt_limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bt_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ca_daylimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ca_apr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ca_fee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ca_min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comparison_apr_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eligibility"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"existing_customers_only"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"existing_customers_note"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestfree_cash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestfree_purchases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min_payment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min_payment_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min_payment_percent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min_salary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"new_customers_note"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"new_customers_only"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"purchases_apr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"purchases_intro_text"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":828}};
    doc.loc.source = {"body":"#import \"@/graphql/fragments/shared/image\"\n#import \"@/graphql/fragments/shared/plan-feature\"\n#import \"@/graphql/fragments/shared/url\"\n\nfragment BasicCreditCard on TCreditCard {\n  brand\n  bt_apr\n  bt_duration\n  code\n  comparison_apr\n  logo {\n    ...BasicImage\n  }\n  name\n  plan_features {\n    ...BasicPlanFeature\n  }\n  purchases_intro_apr\n  purchases_intro_duration\n  slug\n  url {\n    ...BasicUrl\n  }\n}\n\nfragment FullCreditCard on TCreditCard {\n  ...BasicCreditCard\n  bt_available\n  bt_limit\n  bt_text\n  ca_daylimit\n  ca_apr\n  ca_fee\n  ca_min\n  comparison_apr_text\n  eligibility\n  existing_customers_only\n  existing_customers_note\n  interestfree_cash\n  interestfree_purchases\n  min_payment\n  min_payment_amount\n  min_payment_percent\n  min_salary\n  new_customers_note\n  new_customers_only\n  purchases_apr\n  purchases_intro_text\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/shared/image").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/shared/plan-feature").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/shared/url").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["BasicCreditCard"] = oneQuery(doc, "BasicCreditCard");
        
        module.exports["FullCreditCard"] = oneQuery(doc, "FullCreditCard");
        
